<div class="container-fluid p-4">
  <div class="row mb-3">
    <div class="col-md-12">
      <h1>Flagged Contacts</h1>
    </div>
  </div>

  <div *ngIf="errorMessage" class="alert alert-warning alert-dismissible fade show" role="alert">
    <strong>Warning:</strong> {{ errorMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = null"></button>
  </div>

  <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
    {{ successMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="successMessage = null"></button>
  </div>

  <div *ngIf="isLoading" class="text-center p-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2"><em>Loading...</em></p>
  </div>

  <div *ngIf="!isLoading && (!headerRecords || headerRecords.length === 0)" class="alert alert-info">
    <p><em>No flagged contacts found.</em></p>
  </div>

  <div *ngIf="!isLoading && headerRecords && headerRecords.length > 0">
    <div class="row">
      <div class="col-12">
        <h3>Association Contacts</h3>
        <div class="header-grid-container" style="max-height: 300px; overflow-y: auto; overflow-x: auto; border: 1px solid #dee2e6; border-radius: 0.25rem;">
          <table class="table table-striped table-hover" style="margin-bottom: 0;">
            <thead class="table-dark">
              <tr>
                <th (click)="onHeaderSort($event, 'contactId')" style="cursor: pointer; user-select: none;">
                  Contact ID {{ getHeaderSortIcon('contactId') }}
                </th>
                <th (click)="onHeaderSort($event, 'lastName')" style="cursor: pointer; user-select: none;">
                  Last Name {{ getHeaderSortIcon('lastName') }}
                </th>
                <th (click)="onHeaderSort($event, 'firstName')" style="cursor: pointer; user-select: none;">
                  First Name {{ getHeaderSortIcon('firstName') }}
                </th>
                <th (click)="onHeaderSort($event, 'middleNames')" style="cursor: pointer; user-select: none;">
                  Middle Names {{ getHeaderSortIcon('middleNames') }}
                </th>
                <th (click)="onHeaderSort($event, 'address')" style="cursor: pointer; user-select: none;">
                  Address {{ getHeaderSortIcon('address') }}
                </th>
                <th (click)="onHeaderSort($event, 'city')" style="cursor: pointer; user-select: none;">
                  City {{ getHeaderSortIcon('city') }}
                </th>
                <th (click)="onHeaderSort($event, 'state')" style="cursor: pointer; user-select: none;">
                  State {{ getHeaderSortIcon('state') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of headerRecords"
                  (click)="onHeaderRowSelected(record)"
                  (contextmenu)="onHeaderRowContextMenu($event, record)"
                  [class.table-active]="selectedHeaderRecord?.contactId === record.contactId"
                  style="cursor: pointer;">
                <td>{{ record.contactId }}</td>
                <td>{{ record.lastName }}</td>
                <td>{{ record.firstName }}</td>
                <td>{{ record.middleNames }}</td>
                <td>{{ record.address }}</td>
                <td>{{ record.city }}</td>
                <td>{{ record.state }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div *ngIf="contextMenuVisible"
         class="context-menu"
         [style.left.px]="contextMenuX"
         [style.top.px]="contextMenuY"
         (click)="$event.stopPropagation()">
      <button type="button"
              class="context-menu-item"
              (click)="onSyncStatusClicked($event)"
              [disabled]="isSyncingStatus">
        <span *ngIf="isSyncingStatus" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Sync Status
      </button>
    </div>

    <div *ngIf="selectedHeaderRecord" class="row mt-4">
      <div [class.col-md-6]="showFlyout && selectedSubRecord" [class.col-12]="!showFlyout || !selectedSubRecord">
        <div *ngIf="subRecords === null" class="text-center p-4">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2"><em>Loading sub records...</em></p>
        </div>
        <div *ngIf="subRecords && subRecords.length > 0">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="mb-0">OFAC Contacts</h4>
            <button class="btn btn-primary"
                    (click)="onExcludeClicked($event, selectedSubRecord)"
                    [disabled]="!selectedSubRecord || isExcluding || !userContext.hasDataWriteRole()"
                    title="Mark match as a false positive"
                    *ngIf="userContext.hasDataWriteRole()">
              <span *ngIf="isExcluding" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              <span *ngIf="isExcluding">Excluding...</span>
              <span *ngIf="!isExcluding">Exclude</span>
            </button>
          </div>
          <div class="table-responsive">
            <table class="table table-striped table-sm table-hover">
              <thead class="table-secondary">
                <tr>
                  <th>OFAC ID</th>
                  <th>Last Name</th>
                  <th>First Name</th>
                  <th>Middle Names</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let subRecord of subRecords"
                    (click)="onSubRecordSelected(subRecord)"
                    [class.table-active]="isSubRecordSelected(subRecord)"
                    style="cursor: pointer;">
                  <td>{{ subRecord.ofacContactId || 'N/A' }}</td>
                  <td>{{ subRecord.lastName }}</td>
                  <td>{{ subRecord.firstName }}</td>
                  <td>{{ subRecord.middleNames }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div *ngIf="subRecords && subRecords.length === 0" class="alert alert-info">
          <p><em>No sub records found for this contact.</em></p>
        </div>
      </div>

      <div *ngIf="showFlyout && selectedSubRecord" class="col-md-6">
        <div class="card border-primary">
          <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
            <h5 class="mb-0">OFAC Contact Details</h5>
            <button class="btn btn-sm btn-light" (click)="closeFlyout()" title="Close details">×</button>
          </div>
          <div class="card-body">
            <div *ngIf="selectedSubRecord.addresses && selectedSubRecord.addresses.length > 0">
              <h6 class="card-subtitle mb-3">Addresses</h6>
              <div *ngFor="let address of selectedSubRecord.addresses" class="mb-2 p-2 bg-light rounded">
                <p class="mb-1"><strong>Address:</strong> {{ address.address }}</p>
                <p class="mb-0"><strong>City:</strong> {{ address.city }}</p>
              </div>
            </div>

            <div *ngIf="selectedSubRecord.aliases && selectedSubRecord.aliases.length > 0">
              <hr />
              <h6 class="card-subtitle mb-3">Aliases</h6>
              <div *ngFor="let alias of selectedSubRecord.aliases" class="mb-2 p-2 bg-light rounded">
                <p class="mb-1"><strong>Last Name:</strong> {{ alias.lastName }}</p>
                <p class="mb-1"><strong>First Name:</strong> {{ alias.firstName }}</p>
                <p class="mb-0"><strong>Middle Names:</strong> {{ alias.middleNames }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

